import { useTranslation } from 'react-i18next'
import { cx } from 'src/utils/cx'
import MediaPreview from '../Common/MediaPreview'

function I2vTaskFrameEntry(props: { mediaId: string; label?: string }) {
  return (
    <div className="flex flex-col gap-1 w-28 justify-between">
      <p className="break-words">{props.label}</p>
      <MediaPreview mediaId={props.mediaId} thumbnail className="rounded" />
    </div>
  )
}

export function I2vTaskFrames(
  props: {
    mediaId?: string
    tailMediaId?: string
  } & StyleProps,
) {
  const { t } = useTranslation(['generation'])

  return (
    <div className={cx('flex gap-2', props.className)}>
      {props.mediaId ? (
        <I2vTaskFrameEntry
          mediaId={props.mediaId}
          label={t('generation:image-to-video.parameters.start-frame.label')}
        />
      ) : null}
      {props.tailMediaId ? (
        <I2vTaskFrameEntry
          mediaId={props.tailMediaId}
          label={t('generation:image-to-video.parameters.end-frame.label')}
        />
      ) : null}
    </div>
  )
}
